import { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Tooltip from '@mui/material/Tooltip'
import { ArrowRightOutlined } from '@ant-design/icons'
import VerifyMicroDeps from './modals/VerifyMicroDeps'
import CreateFundingSource from './modals/CreateFundingSource'
import PermissionGate from '../../helpers/PermissionGate'

const BankAccountPaymentsApplicationState = ({
  bankAccountId,
  bankAccountSource,
  bankAccountDescription,
  setSelectedBankAccount,
  entityId,
  entityIsVerified,
  bankAccountIsVerified,
  bankAccountPaymentsId,
  entityPaymentsVerified,
}) => {
  const [text, setText] = useState('No')
  const [linkText, setLinkText] = useState('Request')
  const [verifyMicroDepsVisible, setVerifyMicroDepsVisible] = useState(false)
  const [applicationVisible, setApplicationVisible] = useState(false)
  const [fundingSourceId, setFundingSourceId] = useState(bankAccountPaymentsId)
  const [fundingSourceVerified, setFundingSourceVerified] = useState(bankAccountIsVerified)

  useEffect(() => {
    setFundingSourceId(bankAccountPaymentsId)
    setFundingSourceVerified(bankAccountIsVerified)
  }, [bankAccountPaymentsId, bankAccountIsVerified])

  useEffect(() => {
    if (bankAccountSource == 'UN' || (fundingSourceId && fundingSourceVerified)) {
      setText('Yes')
      setLinkText('')
      return
    }
    if (fundingSourceId) {
      setText('No')
      setLinkText('Verify')
      return
    }
    setText('No')
    setLinkText('Request')
  }, [fundingSourceId, fundingSourceVerified])

  return (
    <Stack direction='row' spacing={0.5}>
      <Typography variant='primary'>{text}</Typography>
      {linkText && (
        <PermissionGate
          requiredRole='dashboardEditor'
          toolTipText='Only admins and dashboard editors may access the bank account payments verification process'
          readOnly={
            <Link
              component='button'
              disabled
              sx={{
                color: 'grey',
              }}
              underline='none'
            >
              {linkText}
              <ArrowRightOutlined style={{ marginLeft: '3px' }} />
            </Link>
          }
        >
          <Tooltip
            title={
              entityPaymentsVerified ? (
                ''
              ) : (
                <Typography>Payments must be enabled for the entity before enabling payment methods.</Typography>
              )
            }
          >
            <Link
              component='button'
              disabled={!entityPaymentsVerified}
              sx={{
                color: entityPaymentsVerified ? '' : 'grey',
              }}
              underline='none'
              onClick={() => {
                setSelectedBankAccount(bankAccountId)
                if (linkText === 'Request') {
                  setApplicationVisible(true)
                } else if (linkText === 'Verify') {
                  setVerifyMicroDepsVisible(true)
                }
              }}
            >
              {linkText}
              <ArrowRightOutlined style={{ marginLeft: '3px' }} />
            </Link>
          </Tooltip>
        </PermissionGate>
      )}
      {applicationVisible && (
        <CreateFundingSource
          visible={applicationVisible}
          handleCancelModal={() => setApplicationVisible(false)}
          bankAccountId={bankAccountId}
          setApplicationVisible={setApplicationVisible}
          entityId={entityId}
          bankAccountName={bankAccountDescription}
          setFundingSourceId={setFundingSourceId}
        />
      )}
      {verifyMicroDepsVisible && (
        <VerifyMicroDeps
          visible={verifyMicroDepsVisible}
          handleCancelModal={() => setVerifyMicroDepsVisible(false)}
          bankAccountId={bankAccountId}
          bankAccountPaymentsId={bankAccountPaymentsId}
          setVerifyMicroDepsVisible={setVerifyMicroDepsVisible}
          bankAccountName={bankAccountDescription}
          setFundingSourceIsVerified={setFundingSourceVerified}
        />
      )}
    </Stack>
  )
}

export default BankAccountPaymentsApplicationState
